<template>
<el-dialog title="Import Excel File" :visible.sync="modal" top="8vh" width="550px">
    <el-alert show-icon class="mt-n7 mb-2" type="info" effect="dark" :closable="false">
        Guide on how to use the excel parser. <router-link to="/guide" style="color:#fff;">Click Here!</router-link>
    </el-alert>
    <el-form :model="importForm" ref="importForm">
        <el-form-item prop="parser" label="Parsers">
            <el-select v-model="importForm.parser" placeholder="Select Parser" style="width:100%;" clearable @change="onParserChange" @clear="importForm.template = ''">
                <el-option v-for="(parser, index) in importForm.parserOptions" :key="index" :label="parser.label" :value="parser.value"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="template" v-if="importForm.template">
            <a :href="importForm.template">Download Able2Extract Template</a>
        </el-form-item>
        <el-form-item prop="fileList" label="Choose File" class="mt-n2">
            <el-upload action="" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :auto-upload="false" :show-file-list="false" :file-list="importForm.fileList" :multiple="false" :limit="2" :on-change="onChange">
                <el-input :value="filename" readonly style="width: 510px;">
                    <el-button slot="prepend" type="primary">Choose File</el-button>
                </el-input>
            </el-upload>
        </el-form-item>
        <el-form-item class="mb-n3">
            <div style="float:right;">
                <el-button size="medium" type="danger" plain @click="onCancel">Cancel</el-button>
                <el-button size="medium" style="" type="primary" :disabled="loading" :loading="loading" @click="onSubmit">Submit</el-button>
            </div>
        </el-form-item>
    </el-form>
</el-dialog>
</template>

<script>
import api from '@/services/api'
export default {
    data: () => ({
        modal: false,
        importForm: {
           parser: "",
           parserOptions: [],
           fileList: [],
           filename: "",
           template: ""
        },
        filename: "",
        loading: false
    }),
    created() {
        this.loadParsers()
    },
    methods: {
        onParserChange(data){
            let result = this.importForm.parserOptions.filter(e => e.value === data)[0];
            this.importForm.template = result.template
        },
        onChange(files, fileList) {
            this.importForm.fileList = [];
            this.importForm.fileList.push(files.raw);
            this.filename = files.name
        },
        handleModalView() {
            this.modal = !this.modal
        },
        async loadParsers(){
            let response = await api.get('/nodeparser/brands')
            this.importForm.parserOptions = response.data.map(e => {
                return {
                    value: e.id,
                    label: `${e.brandname} - ${e.requestType}`,
                    brandName: e.brandname,
                    requestType: e.requestType,
                    template: e.parserTemplate
                }
            })
        },
        async onSubmit(){
            this.loading = true
            try{
                if(!this.importForm.parser) return this.$message({ type: 'error', message: 'Please select parser!' })
                if(this.importForm.fileList.length === 0) return this.$message({ type: 'error', message: 'Please upload file!' })
                if(this.importForm.fileList[0].type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return this.$message({ type: 'error', message: 'Incorrect file format! Must be a xlsx file.' })
                
                let result = this.importForm.parserOptions.filter(e => e.value === this.importForm.parser)[0]
                let formData = new FormData()
                formData.append("myFile", this.importForm.fileList[0])
                formData.append("brandName", result.brandName)
                formData.append("type", result.requestType)
                let response = await api.post("/nodeparser", formData)
                console.log(response.data)
                this.onCancel()
                this.$emit('onSuccess', response.data)
            }catch(error){
                console.log(error)
            }finally{
                this.loading = false
            }
        },
        onCancel() {
            this.importForm.parser = '' 
            this.importForm.template = '' 
            this.importForm.fileList = []
            this.handleModalView();
        }
    }
}
</script>

<style scoped>
.alert-info{
    word-break: break-word;
}
</style>